import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <section className="fm-section" style={{ paddingTop: '7rem' }}>
      <div className="fm-container" style={{ textAlign: 'center' }}>
        <h1 style={{ fontFamily: 'var(--fm-display)', fontSize: '2rem' }}>
          Page not found
        </h1>
        <p style={{ color: 'var(--fm-muted)', marginBottom: '1.5rem' }}>
          That link does not match a page on GearsZone.
        </p>
        <Link className="fm-btn fm-btn--primary" to="/">
          Back to home
        </Link>
      </div>
    </section>
  );
}
